



// import React, { useEffect, useRef, useState } from 'react';
// import { FiMenu, FiX, FiPhone, FiMail, FiArrowRight, FiChevronRight, FiChevronDown, FiSettings, FiShoppingCart } from 'react-icons/fi';
// import { Link, NavLink } from 'react-router-dom';
// import logo from '../assest/company logo.png';
// import { categories, slugify } from '../data/categories';

// // Every category's own first product photo (already correctly imported and
// // paired in src/data/categories.js) is reused here directly — this guarantees
// // each category in the Products menu always shows its real, matching photo
// // instead of a manually-picked placeholder that can go out of sync.
// const categoryImageMap = categories.reduce((map, cat) => {
//   map[cat.title] = cat.items[0]?.img;
//   return map;
// }, {});

// const navLinks = [
//   { label: 'Home', to: '/' },
//   { label: 'About', to: '/about' },
// ];

// const serviceOptions = [
//   {
//     label: 'Manufacturing',
//     to: '/services/manufacturing',
//     icon: FiSettings,
//     desc: 'We manufacture high-quality electrical equipment built for performance, safety & long-term reliability.',
//   },
//   {
//     label: 'Trading',
//     to: '/services/trading',
//     icon: FiShoppingCart,
//     desc: 'We trade a wide range of electrical products from trusted & certified manufacturers.',
//   },
// ];

// export default function Header() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const [productsOpen, setProductsOpen] = useState(false);
//   const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
//   const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
//   const closeTimer = useRef(null);
//   const productsCloseTimer = useRef(null);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 12);
//     onScroll();
//     window.addEventListener('scroll', onScroll, { passive: true });
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   // Header stays transparent over every page's hero image until the user
//   // scrolls — same behaviour on Home, About, Products, Contact, etc.
//   // It never turns solid white; once scrolled, only the nav pill / buttons
//   // remain visible against the still-transparent background.
//   const transparent = !scrolled;

//   useEffect(() => {
//     document.body.style.overflow = isOpen ? 'hidden' : '';
//     return () => {
//       document.body.style.overflow = '';
//     };
//   }, [isOpen]);

//   const openServices = () => {
//     clearTimeout(closeTimer.current);
//     setServicesOpen(true);
//   };
//   const scheduleCloseServices = () => {
//     closeTimer.current = setTimeout(() => setServicesOpen(false), 150);
//   };

//   const openProducts = () => {
//     clearTimeout(productsCloseTimer.current);
//     setProductsOpen(true);
//   };
//   const scheduleCloseProducts = () => {
//     productsCloseTimer.current = setTimeout(() => setProductsOpen(false), 150);
//   };

//   const linkClass = ({ isActive }) =>
//     `relative py-1 text-sm font-semibold transition-colors ${
//       isActive
//         ? 'text-brand-orange'
//         : transparent
//         ? 'text-white/80 hover:text-white'
//         : 'text-navy/70 hover:text-navy'
//     }`;

//   return (
//     <header className={`fixed top-0 z-50 w-full transition-colors duration-300`}>
//       {/* ---------------- MAIN NAV ---------------- */}
//       <div
//         className={`border-b transition-all duration-300 ${
//           transparent || scrolled
//             ? 'border-transparent bg-transparent'
//             : 'border-slate-100 bg-white/95 shadow-sm backdrop-blur'
//         }`}
//       >
//         <div
//           className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-2.5 transition-all duration-300 sm:px-6 lg:px-8"
//         >
//           <Link
//             to="/"
//             className={`group z-10 flex items-center gap-3 overflow-hidden transition-all duration-300 ${
//               scrolled ? 'pointer-events-none w-0 -translate-x-4 opacity-0' : 'w-auto opacity-100'
//             }`}
//             onClick={() => setIsOpen(false)}
//           >
//             <div className="flex h-14 w-14 shrink-0 items-center justify-center">
//               <img src={logo} alt="Prithviraj Corporation Limited" className="h-full w-full object-contain drop-shadow-sm" />
//             </div>
            
//       <div className="block">
//   <p className={`text-base sm:text-xl font-extrabold uppercase leading-tight tracking-tight transition-colors duration-300 ${transparent ? 'text-white' : 'text-navy'}`}>
//     Prithviraj
//   </p>
//   <p className="text-[9px] sm:text-xs font-semibold uppercase tracking-[0.12em] sm:tracking-[0.18em] text-brand-orange whitespace-nowrap">
//     Corporation Limited
//   </p>
// </div>
//           </Link>

//           {/* ---------------- NAV LINKS — pill capsule container ----------------
//               Absolutely centered in the header at all times so it never shifts
//               position when the logo collapses / buttons fade on scroll. */}
//           <nav
//             className={`absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center gap-7 rounded-full border px-6 py-2 transition-colors duration-300 md:flex ${
//               transparent ? 'border-white/15 bg-white/5' : 'border-slate-200 bg-white shadow-sm'
//             }`}
//           >
//             {navLinks.map((link) => (
//               <NavLink key={link.label} to={link.to} className={linkClass} end={link.to === '/'}>
//                 {link.label}
//               </NavLink>
//             ))}

//             {/* ---------------- PRODUCTS MEGA MENU ---------------- */}
//           <div className="relative" onMouseEnter={openProducts} onMouseLeave={scheduleCloseProducts}>
//   <Link
//     to="/products"
//     onClick={() => setProductsOpen(false)}
//     aria-expanded={productsOpen}
//     className={`relative flex items-center gap-1 py-1 text-sm font-semibold transition-colors ${
//       productsOpen
//         ? 'text-brand-orange'
//         : transparent
//         ? 'text-white/80 hover:text-white'
//         : 'text-navy/70 hover:text-navy'
//     }`}
//   >
//     Products
//     <FiChevronDown
//       size={14}
//       className={`transition-transform duration-300 ${productsOpen ? 'rotate-180' : ''}`}
//     />
//   </Link>

// <div
//   className={`absolute left-1/2 top-full z-50 w-[720px] -translate-x-1/2 pt-4 transition-all duration-200 ${
//     productsOpen ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none -translate-y-2 opacity-0'
//   }`}
// >
//   <div className="rounded-2xl border border-slate-100 bg-white p-5 shadow-2xl shadow-navy-900/10">
//     <Link
//       to="/products"
//       onClick={() => setProductsOpen(false)}
//       className="mb-4 flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 transition hover:bg-brand-orange/10"
//     >
//       <div>
//         <p className="text-sm font-bold text-navy">All Products</p>
//         <p className="mt-0.5 text-xs text-slate-400">Browse our full catalogue</p>
//       </div>
//       <FiArrowRight className="text-brand-orange" size={16} />
//     </Link>

//     <div className="grid grid-cols-5 gap-3">
//       {categories.map((cat) => (
//         <Link
//           key={cat.title}
//           to={`/products#${slugify(cat.title)}`}
//           onClick={() => setProductsOpen(false)}
//           className="group flex flex-col items-center gap-2 rounded-xl p-2.5 text-center transition hover:bg-slate-50"
//         >
//           <span className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-xl bg-slate-50 shadow-sm ring-1 ring-slate-100 transition duration-300 group-hover:ring-brand-orange">
//             <img
//               src={categoryImageMap[cat.title]}
//               alt={cat.title}
//               className="h-full w-full object-contain p-1.5 transition duration-300 group-hover:scale-110"
//             />
//           </span>
//           <p className="text-[11px] font-bold leading-tight text-navy transition-colors group-hover:text-brand-orange">
//             {cat.title}
//           </p>
//         </Link>
//       ))}
//     </div>
//   </div>
// </div>
// </div>

//             {/* ---------------- SERVICES DROPDOWN ---------------- */}
//             <div className="relative" onMouseEnter={openServices} onMouseLeave={scheduleCloseServices}>
//               <button
//                 type="button"
//                 onClick={() => setServicesOpen((v) => !v)}
//                 aria-expanded={servicesOpen}
//                 className={`relative flex items-center gap-1 py-1 text-sm font-semibold transition-colors ${
//                   servicesOpen
//                     ? 'text-brand-orange'
//                     : transparent
//                     ? 'text-white/80 hover:text-white'
//                     : 'text-navy/70 hover:text-navy'
//                 }`}
//               >
//                 Services
//                 <FiChevronDown
//                   size={14}
//                   className={`transition-transform duration-300 ${servicesOpen ? 'rotate-180' : ''}`}
//                 />
//               </button>

//               <div
//                 className={`absolute left-1/2 top-full z-50 w-[560px] -translate-x-1/2 pt-4 transition-all duration-200 ${
//                   servicesOpen ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none -translate-y-2 opacity-0'
//                 }`}
//               >
//                 <div className="grid grid-cols-2 gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-2xl shadow-navy-900/10">
//                   {serviceOptions.map((opt) => {
//                     const Icon = opt.icon;
//                     return (
//                       <Link
//                         key={opt.label}
//                         to={opt.to}
//                         onClick={() => setServicesOpen(false)}
//                         className="group rounded-xl p-3 transition hover:bg-slate-50"
//                       >
//                         <div className="flex items-start gap-3">
//                           <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange transition duration-300 group-hover:scale-110 group-hover:bg-brand-orange group-hover:text-white">
//                             <Icon size={20} />
//                           </div>
//                           <div>
//                             <p className="font-bold text-navy">{opt.label}</p>
//                             <p className="mt-1 text-xs leading-relaxed text-slate-500">{opt.desc}</p>
//                           </div>
//                         </div>
//                         <span className="mt-3 block h-[2px] w-0 rounded-full bg-brand-orange transition-all duration-300 group-hover:w-full" />
//                       </Link>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             <NavLink to="/contact" className={linkClass}>
//               Contact
//             </NavLink>
//           </nav>

//           <div
//             className={`z-10 hidden items-center gap-3 overflow-hidden transition-all duration-300 md:flex ${
//               scrolled ? 'pointer-events-none w-0 translate-x-4 opacity-0' : 'w-auto opacity-100'
//             }`}
//           >
//             {/* ---------------- CTA — outlined pill, like "Book a call" ---------------- */}
//          <Link
//   to="/contact"
//   className={`group inline-flex items-center gap-2 whitespace-nowrap rounded-full border-2 border-brand-orange px-5 py-2 text-sm font-semibold transition-colors duration-300 hover:bg-brand-orange hover:text-white ${
//     transparent ? 'text-white' : 'text-brand-orange'
//   }`}
// >
//   Contact us
//   <FiArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
// </Link>
//           </div>

//           <button
//             className={`z-10 shrink-0 rounded-full border p-2 transition hover:border-brand-orange hover:text-brand-orange md:hidden ${
//               transparent ? 'border-white/30 text-white' : 'border-navy/20 text-navy'
//             }`}
//             onClick={() => setIsOpen(!isOpen)}
//             aria-label="Toggle menu"
//             aria-expanded={isOpen}
//           >
//             {isOpen ? <FiX size={20} /> : <FiMenu size={20} />}
//           </button>
//         </div>
//       </div>

//       {/* ---------------- MOBILE OVERLAY + SLIDE-IN PANEL ---------------- */}
//       <div
//         className={`fixed inset-0 z-40 bg-navy-900/50 backdrop-blur-sm transition-opacity duration-300 md:hidden ${
//           isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
//         }`}
//         onClick={() => setIsOpen(false)}
//       />
//       <div
//         className={`fixed right-0 top-0 z-50 flex h-full w-[82%] max-w-xs flex-col bg-white shadow-2xl transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] md:hidden ${
//           isOpen ? 'translate-x-0' : 'translate-x-full'
//         }`}
//       >
//         <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
//           <div className="flex items-center gap-2.5">
//             <img src={logo} alt="Prithviraj Corporation Limited" className="h-9 w-9 object-contain" />
//             <p className="text-sm font-extrabold text-navy">Prithviraj Corp.</p>
//           </div>
//           <button
//             className="rounded-full border border-navy/20 p-2 text-navy transition hover:border-brand-orange hover:text-brand-orange"
//             onClick={() => setIsOpen(false)}
//             aria-label="Close menu"
//           >
//             <FiX size={18} />
//           </button>
//         </div>

//         <nav className="flex flex-1 flex-col gap-1 overflow-y-auto px-3 py-4">
//           {navLinks.map((link) => (
//             <NavLink
//               key={link.label}
//               to={link.to}
//               onClick={() => setIsOpen(false)}
//               end={link.to === '/'}
//               className={({ isActive }) =>
//                 `flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold transition ${
//                   isActive ? 'bg-brand-orange/10 text-brand-orange' : 'text-navy hover:bg-slate-50'
//                 }`
//               }
//             >
//               {link.label}
//               <FiChevronRight size={16} className="opacity-40" />
//             </NavLink>
//           ))}

//           {/* ---------------- PRODUCTS ACCORDION ---------------- */}
//           <button
//             type="button"
//             onClick={() => setMobileProductsOpen((v) => !v)}
//             aria-expanded={mobileProductsOpen}
//             className="flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold text-navy transition hover:bg-slate-50"
//           >
//             Products
//             <FiChevronDown
//               size={16}
//               className={`opacity-60 transition-transform duration-300 ${mobileProductsOpen ? 'rotate-180' : ''}`}
//             />
//           </button>
//           <div
//             className={`overflow-hidden transition-all duration-300 ${
//               mobileProductsOpen ? 'max-h-[420px]' : 'max-h-0'
//             }`}
//           >
//             <div className="grid grid-cols-3 gap-2 overflow-y-auto py-1 pl-2 pr-1" style={{ maxHeight: '380px' }}>
//               <Link
//                 to="/products"
//                 onClick={() => {
//                   setIsOpen(false);
//                   setMobileProductsOpen(false);
//                 }}
//                 className="col-span-3 rounded-lg bg-slate-50 px-3 py-2.5 transition hover:bg-brand-orange/10"
//               >
//                 <p className="text-sm font-bold text-navy">All Products</p>
//                 <p className="text-xs text-slate-400">Browse our full catalogue</p>
//               </Link>
//               {categories.map((cat) => (
//                 <Link
//                   key={cat.title}
//                   to={`/products#${slugify(cat.title)}`}
//                   onClick={() => {
//                     setIsOpen(false);
//                     setMobileProductsOpen(false);
//                   }}
//                   className="group flex flex-col items-center gap-1.5 rounded-lg p-2 text-center transition hover:bg-slate-50"
//                 >
//                   <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg bg-slate-50 ring-1 ring-slate-100 transition group-hover:ring-brand-orange">
//                     <img
//                       src={categoryImageMap[cat.title]}
//                       alt={cat.title}
//                       className="h-full w-full object-contain p-1"
//                     />
//                   </span>
//                   <p className="text-[10px] font-bold leading-tight text-navy group-hover:text-brand-orange">
//                     {cat.title}
//                   </p>
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* ---------------- SERVICES ACCORDION ---------------- */}
//           <button
//             type="button"
//             onClick={() => setMobileServicesOpen((v) => !v)}
//             aria-expanded={mobileServicesOpen}
//             className="flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold text-navy transition hover:bg-slate-50"
//           >
//             Services
//             <FiChevronDown
//               size={16}
//               className={`opacity-60 transition-transform duration-300 ${mobileServicesOpen ? 'rotate-180' : ''}`}
//             />
//           </button>
//           <div
//             className={`overflow-hidden transition-all duration-300 ${
//               mobileServicesOpen ? 'max-h-96' : 'max-h-0'
//             }`}
//           >
//             <div className="space-y-2 py-1 pl-2">
//               {serviceOptions.map((opt) => {
//                 const Icon = opt.icon;
//                 return (
//                   <Link
//                     key={opt.label}
//                     to={opt.to}
//                     onClick={() => {
//                       setIsOpen(false);
//                       setMobileServicesOpen(false);
//                     }}
//                     className="flex items-start gap-3 rounded-xl bg-slate-50 p-3 transition hover:bg-brand-orange/10"
//                   >
//                     <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-orange/10 text-brand-orange">
//                       <Icon size={16} />
//                     </div>
//                     <div>
//                       <p className="text-sm font-bold text-navy">{opt.label}</p>
//                       <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{opt.desc}</p>
//                     </div>
//                   </Link>
//                 );
//               })}
//             </div>
//           </div>

//           <NavLink
//             to="/contact"
//             onClick={() => setIsOpen(false)}
//             className={({ isActive }) =>
//               `flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold transition ${
//                 isActive ? 'bg-brand-orange/10 text-brand-orange' : 'text-navy hover:bg-slate-50'
//               }`
//             }
//           >
//             Contact
//             <FiChevronRight size={16} className="opacity-40" />
//           </NavLink>
//         </nav>

//         <div className="space-y-3 border-t border-slate-100 px-5 py-5">
//           <a href="tel:+916201300588" className="flex items-center gap-2.5 text-sm font-medium text-slate-600">
//             <FiPhone size={15} className="text-brand-orange" /> +91 6201300588
//           </a>
//           <a href="mailto:info@prithvirajlimited.com" className="flex items-center gap-2.5 text-sm font-medium text-slate-600">
//             <FiMail size={15} className="text-brand-orange" /> info@prithvirajlimited.com
//           </a>
//           <Link
//             to="/contact"
//             onClick={() => setIsOpen(false)}
//             className="mt-2 flex items-center justify-center gap-2 rounded-full border-2 border-brand-orange px-4 py-3 text-center text-sm font-semibold text-brand-orange transition hover:bg-brand-orange hover:text-white"
//           >
//             Get Quote <FiArrowRight size={15} />
//           </Link>
//         </div>
//       </div>
//     </header>
//   );
// }



import React, { useEffect, useRef, useState } from 'react';
import { FiMenu, FiX, FiPhone, FiMail, FiArrowRight, FiChevronRight, FiChevronDown, FiSettings, FiShoppingCart } from 'react-icons/fi';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assest/company logo.png';
import { categories, slugify } from '../data/categories';

// Every category's own first product photo (already correctly imported and
// paired in src/data/categories.js) is reused here directly — this guarantees
// each category in the Products menu always shows its real, matching photo
// instead of a manually-picked placeholder that can go out of sync.
const categoryImageMap = categories.reduce((map, cat) => {
  map[cat.title] = cat.items[0]?.img;
  return map;
}, {});

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
];

const serviceOptions = [
  {
    label: 'Manufacturing',
    to: '/services/manufacturing',
    icon: FiSettings,
    desc: 'We manufacture high-quality electrical equipment built for performance, safety & long-term reliability.',
  },
  {
    label: 'Trading',
    to: '/services/trading',
    icon: FiShoppingCart,
    desc: 'We trade a wide range of electrical products from trusted & certified manufacturers.',
  },
];

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const closeTimer = useRef(null);
  const productsCloseTimer = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Header stays transparent over every page's hero image until the user
  // scrolls — same behaviour on Home, About, Products, Contact, etc.
  // It never turns solid white; once scrolled, only the nav pill / buttons
  // remain visible against the still-transparent background.
  const transparent = !scrolled;

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const openServices = () => {
    clearTimeout(closeTimer.current);
    setServicesOpen(true);
  };
  const scheduleCloseServices = () => {
    closeTimer.current = setTimeout(() => setServicesOpen(false), 150);
  };

  const openProducts = () => {
    clearTimeout(productsCloseTimer.current);
    setProductsOpen(true);
  };
  const scheduleCloseProducts = () => {
    productsCloseTimer.current = setTimeout(() => setProductsOpen(false), 150);
  };

  const linkClass = ({ isActive }) =>
    `relative py-1 text-sm font-semibold transition-colors ${
      isActive
        ? 'text-brand-orange'
        : transparent
        ? 'text-white/80 hover:text-white'
        : 'text-navy/70 hover:text-navy'
    }`;

  return (
    <header className={`fixed top-0 z-50 w-full transition-colors duration-300`}>
      {/* ---------------- MAIN NAV ---------------- */}
      <div
        className={`border-b transition-all duration-300 ${
          transparent || scrolled
            ? 'border-transparent bg-transparent'
            : 'border-slate-100 bg-white/95 shadow-sm backdrop-blur'
        }`}
      >
        <div
          className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-2.5 transition-all duration-300 sm:px-6 lg:px-8"
        >
          <Link
            to="/"
            className={`group z-10 flex items-center gap-3 overflow-hidden transition-all duration-300 ${
              scrolled ? 'pointer-events-none w-0 -translate-x-4 opacity-0' : 'w-auto opacity-100'
            }`}
            onClick={() => setIsOpen(false)}
          >
            <div className="flex h-14 w-14 shrink-0 items-center justify-center">
              <img src={logo} alt="Prithviraj Corporation Limited" className="h-full w-full object-contain drop-shadow-sm" />
            </div>

            <div className="block">
              <p className={`text-base sm:text-xl font-extrabold uppercase leading-tight tracking-tight transition-colors duration-300 ${transparent ? 'text-white' : 'text-navy'}`}>
                Prithviraj
              </p>
              <p className="text-[9px] sm:text-xs font-semibold uppercase tracking-[0.12em] sm:tracking-[0.18em] text-brand-orange whitespace-nowrap">
                Corporation Limited
              </p>
            </div>
          </Link>

          {/* ---------------- NAV LINKS — pill capsule container ----------------
              Absolutely centered in the header at all times so it never shifts
              position when the logo collapses / buttons fade on scroll.
              Uses the `lg` breakpoint (1024px) instead of `md` (768px) so
              tablets/iPads (which sit in the 768–1023px range) still get the
              clean hamburger menu instead of a squeezed, overlapping nav. */}
          <nav
            className={`absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center gap-7 rounded-full border px-6 py-2 transition-colors duration-300 lg:flex ${
              transparent ? 'border-white/15 bg-white/5' : 'border-slate-200 bg-white shadow-sm'
            }`}
          >
            {navLinks.map((link) => (
              <NavLink key={link.label} to={link.to} className={linkClass} end={link.to === '/'}>
                {link.label}
              </NavLink>
            ))}

            {/* ---------------- PRODUCTS MEGA MENU ---------------- */}
            <div className="relative" onMouseEnter={openProducts} onMouseLeave={scheduleCloseProducts}>
              <Link
                to="/products"
                onClick={() => setProductsOpen(false)}
                aria-expanded={productsOpen}
                className={`relative flex items-center gap-1 py-1 text-sm font-semibold transition-colors ${
                  productsOpen
                    ? 'text-brand-orange'
                    : transparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-navy/70 hover:text-navy'
                }`}
              >
                Products
                <FiChevronDown
                  size={14}
                  className={`transition-transform duration-300 ${productsOpen ? 'rotate-180' : ''}`}
                />
              </Link>

              <div
                className={`absolute left-1/2 top-full z-50 w-[720px] -translate-x-1/2 pt-4 transition-all duration-200 ${
                  productsOpen ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none -translate-y-2 opacity-0'
                }`}
              >
                <div className="rounded-2xl border border-slate-100 bg-white p-5 shadow-2xl shadow-navy-900/10">
                  <Link
                    to="/products"
                    onClick={() => setProductsOpen(false)}
                    className="mb-4 flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 transition hover:bg-brand-orange/10"
                  >
                    <div>
                      <p className="text-sm font-bold text-navy">All Products</p>
                      <p className="mt-0.5 text-xs text-slate-400">Browse our full catalogue</p>
                    </div>
                    <FiArrowRight className="text-brand-orange" size={16} />
                  </Link>

                  <div className="grid grid-cols-5 gap-3">
                    {categories.map((cat) => (
                      <Link
                        key={cat.title}
                        to={`/products#${slugify(cat.title)}`}
                        onClick={() => setProductsOpen(false)}
                        className="group flex flex-col items-center gap-2 rounded-xl p-2.5 text-center transition hover:bg-slate-50"
                      >
                        <span className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-xl bg-slate-50 shadow-sm ring-1 ring-slate-100 transition duration-300 group-hover:ring-brand-orange">
                          <img
                            src={categoryImageMap[cat.title]}
                            alt={cat.title}
                            className="h-full w-full object-contain p-1.5 transition duration-300 group-hover:scale-110"
                          />
                        </span>
                        <p className="text-[11px] font-bold leading-tight text-navy transition-colors group-hover:text-brand-orange">
                          {cat.title}
                        </p>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* ---------------- SERVICES DROPDOWN ---------------- */}
            <div className="relative" onMouseEnter={openServices} onMouseLeave={scheduleCloseServices}>
              <button
                type="button"
                onClick={() => setServicesOpen((v) => !v)}
                aria-expanded={servicesOpen}
                className={`relative flex items-center gap-1 py-1 text-sm font-semibold transition-colors ${
                  servicesOpen
                    ? 'text-brand-orange'
                    : transparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-navy/70 hover:text-navy'
                }`}
              >
                Services
                <FiChevronDown
                  size={14}
                  className={`transition-transform duration-300 ${servicesOpen ? 'rotate-180' : ''}`}
                />
              </button>

              <div
                className={`absolute left-1/2 top-full z-50 w-[560px] -translate-x-1/2 pt-4 transition-all duration-200 ${
                  servicesOpen ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none -translate-y-2 opacity-0'
                }`}
              >
                <div className="grid grid-cols-2 gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-2xl shadow-navy-900/10">
                  {serviceOptions.map((opt) => {
                    const Icon = opt.icon;
                    return (
                      <Link
                        key={opt.label}
                        to={opt.to}
                        onClick={() => setServicesOpen(false)}
                        className="group rounded-xl p-3 transition hover:bg-slate-50"
                      >
                        <div className="flex items-start gap-3">
                          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange transition duration-300 group-hover:scale-110 group-hover:bg-brand-orange group-hover:text-white">
                            <Icon size={20} />
                          </div>
                          <div>
                            <p className="font-bold text-navy">{opt.label}</p>
                            <p className="mt-1 text-xs leading-relaxed text-slate-500">{opt.desc}</p>
                          </div>
                        </div>
                        <span className="mt-3 block h-[2px] w-0 rounded-full bg-brand-orange transition-all duration-300 group-hover:w-full" />
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>

            <NavLink to="/contact" className={linkClass}>
              Contact
            </NavLink>
          </nav>

          <div
            className={`z-10 hidden items-center gap-3 overflow-hidden transition-all duration-300 lg:flex ${
              scrolled ? 'pointer-events-none w-0 translate-x-4 opacity-0' : 'w-auto opacity-100'
            }`}
          >
            {/* ---------------- CTA — outlined pill, like "Book a call" ---------------- */}
            <Link
              to="/contact"
              className={`group inline-flex items-center gap-2 whitespace-nowrap rounded-full border-2 border-brand-orange px-5 py-2 text-sm font-semibold transition-colors duration-300 hover:bg-brand-orange hover:text-white ${
                transparent ? 'text-white' : 'text-brand-orange'
              }`}
            >
              Contact us
              <FiArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>

          <button
            className={`z-10 shrink-0 rounded-full border p-2 transition hover:border-brand-orange hover:text-brand-orange lg:hidden ${
              transparent ? 'border-white/30 text-white' : 'border-navy/20 text-navy'
            }`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            {isOpen ? <FiX size={20} /> : <FiMenu size={20} />}
          </button>
        </div>
      </div>

      {/* ---------------- MOBILE / TABLET OVERLAY + SLIDE-IN PANEL ---------------- */}
      <div
        className={`fixed inset-0 z-40 bg-navy-900/50 backdrop-blur-sm transition-opacity duration-300 lg:hidden ${
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={() => setIsOpen(false)}
      />
      <div
        className={`fixed right-0 top-0 z-50 flex h-full w-[82%] max-w-xs flex-col bg-white shadow-2xl transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <div className="flex items-center gap-2.5">
            <img src={logo} alt="Prithviraj Corporation Limited" className="h-9 w-9 object-contain" />
            <p className="text-sm font-extrabold text-navy">Prithviraj Corp.</p>
          </div>
          <button
            className="rounded-full border border-navy/20 p-2 text-navy transition hover:border-brand-orange hover:text-brand-orange"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <FiX size={18} />
          </button>
        </div>

        <nav className="flex flex-1 flex-col gap-1 overflow-y-auto px-3 py-4">
          {navLinks.map((link) => (
            <NavLink
              key={link.label}
              to={link.to}
              onClick={() => setIsOpen(false)}
              end={link.to === '/'}
              className={({ isActive }) =>
                `flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold transition ${
                  isActive ? 'bg-brand-orange/10 text-brand-orange' : 'text-navy hover:bg-slate-50'
                }`
              }
            >
              {link.label}
              <FiChevronRight size={16} className="opacity-40" />
            </NavLink>
          ))}

          {/* ---------------- PRODUCTS ACCORDION ---------------- */}
          <button
            type="button"
            onClick={() => setMobileProductsOpen((v) => !v)}
            aria-expanded={mobileProductsOpen}
            className="flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold text-navy transition hover:bg-slate-50"
          >
            Products
            <FiChevronDown
              size={16}
              className={`opacity-60 transition-transform duration-300 ${mobileProductsOpen ? 'rotate-180' : ''}`}
            />
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              mobileProductsOpen ? 'max-h-[420px]' : 'max-h-0'
            }`}
          >
            <div className="grid grid-cols-3 gap-2 overflow-y-auto py-1 pl-2 pr-1" style={{ maxHeight: '380px' }}>
              <Link
                to="/products"
                onClick={() => {
                  setIsOpen(false);
                  setMobileProductsOpen(false);
                }}
                className="col-span-3 rounded-lg bg-slate-50 px-3 py-2.5 transition hover:bg-brand-orange/10"
              >
                <p className="text-sm font-bold text-navy">All Products</p>
                <p className="text-xs text-slate-400">Browse our full catalogue</p>
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.title}
                  to={`/products#${slugify(cat.title)}`}
                  onClick={() => {
                    setIsOpen(false);
                    setMobileProductsOpen(false);
                  }}
                  className="group flex flex-col items-center gap-1.5 rounded-lg p-2 text-center transition hover:bg-slate-50"
                >
                  <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg bg-slate-50 ring-1 ring-slate-100 transition group-hover:ring-brand-orange">
                    <img
                      src={categoryImageMap[cat.title]}
                      alt={cat.title}
                      className="h-full w-full object-contain p-1"
                    />
                  </span>
                  <p className="text-[10px] font-bold leading-tight text-navy group-hover:text-brand-orange">
                    {cat.title}
                  </p>
                </Link>
              ))}
            </div>
          </div>

          {/* ---------------- SERVICES ACCORDION ---------------- */}
          <button
            type="button"
            onClick={() => setMobileServicesOpen((v) => !v)}
            aria-expanded={mobileServicesOpen}
            className="flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold text-navy transition hover:bg-slate-50"
          >
            Services
            <FiChevronDown
              size={16}
              className={`opacity-60 transition-transform duration-300 ${mobileServicesOpen ? 'rotate-180' : ''}`}
            />
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              mobileServicesOpen ? 'max-h-96' : 'max-h-0'
            }`}
          >
            <div className="space-y-2 py-1 pl-2">
              {serviceOptions.map((opt) => {
                const Icon = opt.icon;
                return (
                  <Link
                    key={opt.label}
                    to={opt.to}
                    onClick={() => {
                      setIsOpen(false);
                      setMobileServicesOpen(false);
                    }}
                    className="flex items-start gap-3 rounded-xl bg-slate-50 p-3 transition hover:bg-brand-orange/10"
                  >
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-orange/10 text-brand-orange">
                      <Icon size={16} />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-navy">{opt.label}</p>
                      <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{opt.desc}</p>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>

          <NavLink
            to="/contact"
            onClick={() => setIsOpen(false)}
            className={({ isActive }) =>
              `flex items-center justify-between rounded-xl px-4 py-3 text-sm font-semibold transition ${
                isActive ? 'bg-brand-orange/10 text-brand-orange' : 'text-navy hover:bg-slate-50'
              }`
            }
          >
            Contact
            <FiChevronRight size={16} className="opacity-40" />
          </NavLink>
        </nav>

        <div className="space-y-3 border-t border-slate-100 px-5 py-5">
          <a href="tel:+916201300588" className="flex items-center gap-2.5 text-sm font-medium text-slate-600">
            <FiPhone size={15} className="text-brand-orange" /> +91 6201300588
          </a>
          <a href="mailto:info@prithvirajlimited.com" className="flex items-center gap-2.5 text-sm font-medium text-slate-600">
            <FiMail size={15} className="text-brand-orange" /> info@prithvirajlimited.com
          </a>
          <Link
            to="/contact"
            onClick={() => setIsOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 rounded-full border-2 border-brand-orange px-4 py-3 text-center text-sm font-semibold text-brand-orange transition hover:bg-brand-orange hover:text-white"
          >
            Get Quote <FiArrowRight size={15} />
          </Link>
        </div>
      </div>
    </header>
  );
}